module.exports = __webpack_public_path__ + "img/rejadet.d98fdd80.jpg";